module.exports = __webpack_public_path__ + "static/media/placas (2).7dcc57c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Placas/placas (2).jpg
// module id = 352
// module chunks = 0